const CookiePolicyData = [
  {
    id: "what-are-cookies",
    title: "What Are Cookies?",
    content: [
      "Cookies are small text files placed on your device (computer, tablet, or smartphone) by websites you visit. They are widely used to make websites work efficiently, remember your preferences, and provide information to website owners.",
      "Cookies do not contain executable code and cannot carry viruses. They are simply data files that store information about your interactions with a website.",
    ],
  },
  {
    id: "how-we-use-cookies",
    title: "How KodeVedic Uses Cookies",
    content: [
      "KodeVedic uses cookies to deliver a seamless and personalised learning experience. Specifically, we use them to:",
      "• Keep you logged into your account securely across page visits (session authentication).",
      "• Remember your course progress and interface preferences (e.g., video playback speed).",
      "• Understand how learners navigate the Platform so we can improve content discovery and usability.",
      "• Process payments securely through Razorpay.",
    ],
  },
  {
    id: "types-of-cookies",
    title: "Types of Cookies We Use",
    content: [
      "Essential / Strictly Necessary Cookies: These are required for the Platform to function. They manage your login session and security tokens. Without these cookies, features such as logging in and accessing your courses are not possible. These cookies cannot be disabled.",
      "Functional Cookies: These cookies remember your choices and settings (such as your preferred language or video quality) to provide a more personalised experience. They persist across browser sessions.",
      "Analytics Cookies: We use analytics tools to collect anonymised, aggregated data about how visitors use our Platform — which pages are most visited, where users click, and how long they spend on each section. This helps us improve the Platform. Individual users are not identified.",
      "Payment Cookies: Razorpay, our payment processor, places cookies necessary to securely facilitate payment transactions. These are governed by Razorpay's own Cookie and Privacy Policy.",
    ],
  },
  {
    id: "third-party-cookies",
    title: "Third-Party Cookies",
    content: [
      "Some functionality on the KodeVedic Platform relies on third-party services that may set their own cookies on your device:",
      "Razorpay: Used for secure payment processing. Razorpay cookies are set only during checkout flows.",
      "YouTube / Video Embeds: Some course previews may embed YouTube videos. If YouTube is loaded, it may place its own cookies subject to Google's Privacy Policy.",
      "We do not have direct control over third-party cookies. Please review the respective privacy policies of these services.",
    ],
  },
  {
    id: "managing-cookies",
    title: "Managing Your Cookie Preferences",
    content: [
      "You can control cookies through your browser settings. Most browsers allow you to view, delete, and block cookies. Here are links to instructions for common browsers:",
      "• Google Chrome: Settings → Privacy and Security → Cookies and other site data",
      "• Mozilla Firefox: Options → Privacy & Security → Cookies and Site Data",
      "• Safari: Preferences → Privacy → Manage Website Data",
      "• Microsoft Edge: Settings → Cookies and Site Permissions → Cookies and Site Data",
      "Please be aware that disabling essential cookies will prevent you from logging into your account and accessing purchased courses. Disabling analytics cookies will not affect your ability to use the Platform.",
    ],
  },
  {
    id: "updates",
    title: "Updates to This Policy",
    content: [
      "We may update this Cookie Policy from time to time to reflect changes in our practices or for legal, operational, or regulatory reasons. We will notify you of material changes by posting a notice on the Platform.",
      "If you have any questions about our use of cookies, please contact us at connect@kodevedic.com.",
    ],
  },
];

export default CookiePolicyData;
